import React from "react";
import { Link } from "react-router-dom";
import { business } from "../data/content";
import Leaf from "./Leaf";

export default function Footer() {
  return (
    <footer className="bg-moss text-cream">
      <div className="container-page grid gap-12 py-16 md:grid-cols-3">
        <div>
          <Link to="/" className="inline-flex items-center">
            <img
              src={business.logo}
              alt={business.name}
              className="h-14 w-auto brightness-0 invert"
            />
            <span className="sr-only">{business.name}</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm text-cream/70">
            We treat you just the way you love yourself — remedial massage,
            facials and body treatments in East Victoria Park.
          </p>
        </div>

        <div className="text-sm">
          <p className="font-display text-lg text-cream/90">Visit</p>
          <p className="mt-3 text-cream/70">{business.address}</p>
          <a
            href={business.mapHref}
            className="mt-1 inline-block text-clay hover:text-cream transition-colors"
          >
            Get directions
          </a>
          <p className="mt-4">
            <a
              href={business.phoneHref}
              className="text-cream/90 hover:text-cream"
            >
              {business.phoneDisplay}
            </a>
          </p>
          <p>
            <a
              href={`mailto:${business.email}`}
              className="text-cream/70 hover:text-cream"
            >
              {business.email}
            </a>
          </p>
        </div>

        <div className="text-sm">
          <p className="font-display text-lg text-cream/90">Quick links</p>
          <ul className="mt-3 space-y-1.5">
            <li>
              <Link to="/" className="text-cream/70 hover:text-cream">
                Home
              </Link>
            </li>
            <li>
              <Link to="/booking" className="text-cream/70 hover:text-cream">
                Booking
              </Link>
            </li>
            <li>
              <a
                href={business.bookingUrl}
                className="text-cream/70 hover:text-cream"
              >
                Online booking
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-cream/15">
        <div className="container-page flex flex-col-reverse items-center gap-3 py-6 text-xs text-cream/50 md:flex-row md:justify-between">
          <p>
            © {new Date().getFullYear()} {business.name}. All rights reserved.
          </p>
          <Link to="/booking" className="hover:text-cream/80">
            Book a session
          </Link>
        </div>
      </div>
    </footer>
  );
}
